import { MutationTuple } from "@apollo/client";

import { VStack } from "@chakra-ui/react";

import { FragmentType, getFragmentData, graphql } from "@/__generated__";
import {
  MUserProfilePage_UpdateProfileMutation,
  MUserProfilePage_UpdateProfileMutationVariables,
} from "@/__generated__/graphql";
import General from "@/components/UserProfile/General";
import Workspaces from "@/components/UserProfile/Workspaces";

const UserProfile_User = graphql(`
  fragment UserProfile_User on User {
    id
    ...UserProfileGeneral_User
    ...UserProfileWorkspaces_User
  }
`);

interface Props {
  user: FragmentType<typeof UserProfile_User>;
  updateProfileMutation: MutationTuple<
    MUserProfilePage_UpdateProfileMutation,
    MUserProfilePage_UpdateProfileMutationVariables
  >;
}

function UserProfile({ updateProfileMutation, ...props }: Props) {
  const user = getFragmentData(UserProfile_User, props.user);
  return (
    <VStack align="flex-start" spacing={4} sx={{ "& > *": { md: { minWidth: "lg" } } }}>
      <General updateProfileMutation={updateProfileMutation} user={user} />
      <Workspaces user={user} />
    </VStack>
  );
}

export default UserProfile;
